/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmptyResponse,
  HitListRequest,
} from '../models/index';
import {
    EmptyResponseFromJSON,
    EmptyResponseToJSON,
    HitListRequestFromJSON,
    HitListRequestToJSON,
} from '../models/index';

export interface HitlistRequest {
    sessionId: string;
    hitListRequest?: HitListRequest;
}

/**
 * 
 */
export class WSAApi extends runtime.BaseAPI {

    /**
     * Create a hitlist from the selected entities
     */
    async hitlistRaw(requestParameters: HitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling hitlist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sequenceAnalyzer/session/{sessionId}/hitlist`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HitListRequestToJSON(requestParameters.hitListRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a hitlist from the selected entities
     */
    async hitlist(requestParameters: HitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.hitlistRaw(requestParameters, initOverrides);
    }

}
